export default __webpack_public_path__ + "static/media/g4.3ce19385.PNG";